import { useState } from 'react';
import { beginSignIn } from '../auth';
import { app, describeError } from '../state/app';

/**
 * One button. Entra owns the password, the first-sign-in password change, MFA
 * and every other credential step, so there is nothing left for this screen to
 * collect — the email/password form, the busy spinner and the
 * FORCE_CHANGE_PASSWORD branch all left with Cognito.
 *
 * It is deliberately a BUTTON and not an automatic redirect on mount. Bouncing
 * every cold load of the site to login.microsoftonline.com without a user
 * gesture is hostile, and it makes the site unvisitable for anyone who is not
 * signing in. That rule was true here and broken one screen later: auth.ts used
 * to fire the same redirect from a mount effect the moment a token could not be
 * renewed silently. It no longer does — a session that ends comes back HERE,
 * carrying `signInNotice`, and the gesture is this button.
 *
 * TWO PLACES A REASON CAN COME FROM, and they are different facts:
 *   `signInNotice` — why the app sent the parent back here. Entra's own words
 *                    after a refused redirect, or an expired session. Present on
 *                    arrival, before anything on this screen has been touched.
 *   `error`        — the redirect never started at all: a blocked navigation, or
 *                    MSAL refusing a redirectUri the registration does not list.
 */
export function SignIn() {
  const { signInNotice } = app.use();
  const [error, setError] = useState<string | null>(null);

  const start = async () => {
    setError(null);
    try {
      await beginSignIn();
    } catch (err) {
      setError(describeError(err));
    }
  };

  return (
    <div className="centered">
      <div className="panel">
        <h1>Showling</h1>
        <p className="sub">Parent sign-in. The child never sees this screen.</p>

        {signInNotice && <div className="gate">{signInNotice}</div>}
        {error && <div className="err">{error}</div>}

        <button className="big" type="button" onClick={() => void start()}>
          Sign in
        </button>
        <p className="sub">
          Sign-in happens on Microsoft's page, then you come straight back here.
        </p>
      </div>
    </div>
  );
}
